import { Box } from '@mui/material'
import React, { useState } from 'react'
import RuleSetPreview from './RuleSetPreview'
import { IRuleSet } from '../../../DTStudio/interfaces'
import BusinessRulesLabel from './BusinessRulesLabel'
import { useTranslation } from 'react-i18next'

interface BusinessRuleSetsViewProps {
    rulesets?: IRuleSet[]
}

const BusinessRuleSetsView: React.FC<BusinessRuleSetsViewProps> = ({
    rulesets,
}) => {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState(false)
    if (!rulesets || rulesets.length === 0) {
        return <BusinessRulesLabel text={t('businessRuleset')} />
    }
    return (
        <Box sx={{ width: '100%' }}>
            {rulesets.map((ruleSet, index) => (
                <RuleSetPreview
                    ruleSet={ruleSet}
                    key={ruleSet.id}
                    index={index}
                    expanded={expanded}
                    setExpanded={setExpanded}
                />
            ))}
        </Box>
    )
}

export default BusinessRuleSetsView
